<template>
  <div>
    <!-- 标题及按钮 -->
    <mtd-row>
      <mtd-col :span="12" class="height-full">
        <div class="page-title-32">{{ $getText('wenshu_web_document_flow_details', '文件流转详情') }}</div>
      </mtd-col>
    </mtd-row>
    <!-- 数据来源检索 -->
    <mtd-row class="search-block" style="margin-top: 12px;" :gutter="16">
      <mtd-form :model="query_params" :label-width="120">
        <mtd-col :span="8" style="padding-left: 0">
          <mtd-form-item prop="params" :label="$getText('wenshu_web_document_name', '文档名称') + ':'">
            <mtd-input :placeholder="$getText('wenshu_web_enter_document_name_to_query', '请输入需要查询的文档名称')" style="width: 100%;" v-model="query_params.fileName" clearable/>
          </mtd-form-item>
        </mtd-col>
        <mtd-col :span="8">
          <mtd-form-item prop="createTime" :label="$getText('wenshu_web_operation_time_colon', '操作时间')">
            <mtd-date-picker type="daterange" :placeholder="$getText('wenshu_web_select_time', '选择时间')" style="width: 100%" value-format="yyyy-MM-dd"
                             v-model="query_params.operate_time" clearable/>
          </mtd-form-item>
        </mtd-col>
        <mtd-col :span="8" style="padding-right: 0">
          <mtd-form-item prop="appealStatus" :label="$getText('wenshu_web_operation_type', '操作类型')">
            <mtd-select style="width: 100%;" v-model="query_params.operateType" :placeholder="$getText('wenshu_web_please_select', '请选择')" clearable>
              <mtd-option :label="$getText('wenshu_web_view', '查看')" value="查看"/>
              <mtd-option :label="$getText('wenshu_web_forward', '转发')" value="转发"/>
              <mtd-option :label="$getText('wenshu_web_download', '下载')" value="下载"/>
              <mtd-option :label="$getText('wenshu_web_external_send', '外发')" value="外发"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-col>
        <mtd-col :span="8" style="padding-left: 0">
          <mtd-form-item prop="dataSource" :label="$getText('wenshu_web_data_source', '数据来源') + ':'" style="margin-bottom: 0;">
            <mtd-select v-model="query_params.dataSource" style="width: 100%" :placeholder="$getText('wenshu_web_please_select', '请选择')" clearable>
              <mtd-option :label="$getText('wenshu_web_xuecheng', '学城')" value="km"/>
              <mtd-option :label="$getText('wenshu_web_module_daxiang', '大象')" value="xm"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-col>
        <mtd-col :span="8" :offset="8" style="padding-right: 0; text-align: right;">
          <mtd-button type="text-primary" style="width: 70px;" @click="reset_search_form">{{ $getText('wenshu_web_reset', '重置') }}</mtd-button>
          <mtd-button ghost type="primary" style="width: 80px;" @click="list_file_detail">{{ $getText('wenshu_web_query', '查询') }}</mtd-button>
        </mtd-col>
      </mtd-form>
    </mtd-row>
    <!-- 文件流转详情表格 -->
    <mtd-table :data="alarm_detail_list" size="small" style="margin-top:12px;" :empty-text="$getText('wenshu_web_no_data', '暂无数据')">
      <mtd-table-column prop="filename" :label="$getText('wenshu_web_document_name', '文档名称')" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.dataSource === 'xm'">{{ scope.row.filename }}</span>
          <span v-if="scope.row.dataSource === 'km'">
              <a :href="'https://km.sankuai.com/page/'+scope.row.filemd5" target="_blank">{{ scope.row.filename }}</a>
            </span>
        </template>
      </mtd-table-column>
      <mtd-table-column prop="misidObj" label="misID" width="100" show-overflow-tooltip/>
      <mtd-table-column prop="nameObj" :label="$getText('wenshu_web_name', '姓名')" width="100" show-overflow-tooltip/>
      <mtd-table-column prop="orgPathNameObj" :label="$getText('wenshu_web_organization_structure', '查看组织架构')" width="260" show-overflow-tooltip/>
      <mtd-table-column prop="operateStartTimeObj" :label="$getText('wenshu_web_operation_time', '操作时间')" width="140"/>
      <mtd-table-column prop="tag" :label="$getText('wenshu_web_operation_behavior', '操作行为')" width="100">
        <template slot-scope="scope">
          <mtd-popover v-if="scope.row.tag === '转发'" trigger="click" placement="top">
            <div slot="content">
              <span>{{ scope.row.actionExtObj }}</span>
            </div>
            <span style="cursor: pointer;">{{ getI18nTag(scope.row.tag) }}</span>
          </mtd-popover>
          <span v-else>{{ getI18nTag(scope.row.tag) }}</span>
        </template>
      </mtd-table-column>
      <mtd-table-column prop="sourceObj" :label="$getText('wenshu_web_data_source_1', '数据源')" width="80"/>
      <mtd-table-column prop="viewUserCnt" :label="$getText('wenshu_web_data_source', '数据来源')" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.dataSource === 'xm'">{{ $getText('wenshu_web_module_daxiang', '大象') }}</span>
          <span v-if="scope.row.dataSource === 'km'">{{ $getText('wenshu_web_xuecheng', '学城') }}</span>
        </template>
      </mtd-table-column>
      <mtd-table-column prop="reportReason" :label="$getText('wenshu_web_report_reason', '举报原因')" width="260" show-overflow-tooltip/>
      <mtd-table-column :label="$getText('wenshu_web_operation', '操作')" width="100">
        <template slot-scope="scope">
          <mtd-button type="text" size="small" @click="report(scope.row)" style="color: #0a70f5;padding-left: 0">
            {{ $getText('wenshu_web_report', '举报') }}
          </mtd-button>
        </template>
      </mtd-table-column>
    </mtd-table>
    <div style="text-align: right;margin-top: 12px;">
      <mtd-pagination size="small" :total="query_params.tn"
                      :page-size="query_params.sn"
                      :current-page.sync="query_params.cn" @change="change_page"/>
    </div>

    <!-- 举报Modal -->
    <mtd-modal v-model="reportModal" :title="$getText('wenshu_web_report', '举报')" @close="closeModal" width="600px">
      <mtd-form>
        <mtd-form-item :label="$getText('wenshu_web_report_reason', '举报原因')" prop="desc" :label-width="90" class="mtd-form-item-required">
          <mtd-textarea :placeholder="$getText('wenshu_web_please_fill_in_report_reason_in_detail', '请详细填写举报原因')" v-model="form_data.reportReason" style="width: 100%;resize: none"
                        rows="5"/>
        </mtd-form-item>
      </mtd-form>
      <div slot="footer" class="demo-modal-footer">
        <mtd-button @click="closeModal">{{ $getText('wenshu_web_cancel', '取消') }}</mtd-button>
        <mtd-button type="primary" :loading="submitLoading" @click="submitReason"
                    :disabled="form_data.reportReason.trim() === ''">
          {{ $getText('wenshu_web_confirm', '确认') }}
        </mtd-button>
      </div>
    </mtd-modal>
  </div>
</template>

<script>

import {mapActions} from 'vuex'

export default {
  name: "alert_detail",
  data() {
    return {
      alarm_detail_list: [],
      reportModal: false,
      submitLoading: false,
      query_params: {
        fileName: '',
        fileNameLike: '',
        operate_time: [],
        operateType: '',
        dataSource: null,
        queryDt: null,
        cn: 1, // 当前页面
        sn: 10, // 每页大小
        tn: 0 // 总条数
      },
      form_data: {
        detailId: null,
        fileMd5: null,
        fileName: null,
        misId: null,
        reportReason: ''
      }
    }
  },
  mounted: function () {
    // 1.首先获取传递的参数
    let filename = this.$route.params.filename;
    let dataSource = this.$route.params.dataSource;
    let queryDt = this.$route.params.queryDt;
    if (filename && filename !== '') {
      this.query_params.fileName = filename;
    }
    if (dataSource && dataSource !== '') {
      this.query_params.dataSource = dataSource;
    }
    if (queryDt && (/^\d{8}$/.test(queryDt))) {
      this.query_params.queryDt = queryDt;
    }
    this.list_file_detail();
    this.$emit("reload_active_tab");
  },
  methods: {
    // API方法
    ...mapActions({
      api_list_file_detail: 'api_file_trace_query_file_detail',
      api_file_detail_report: 'api_file_trace_file_detail_report',
    }),
    list_file_detail() {
      if (this.query_params.operate_time.length === 2) {
        this.query_params.operateStartTime = this.query_params.operate_time[0] + " 00:00:00";
        this.query_params.operateEndTime = this.query_params.operate_time[1] + " 23:59:59";
      } else {
        this.query_params.operateStartTime = null;
        this.query_params.operateEndTime = null;
      }
      this.query_params.limit = this.query_params.sn;
      this.query_params.page = this.query_params.cn;
      this.api_list_file_detail(this.query_params).then((res) => {
        if (res.code === 0) {
          let {currentPage, limit, total, items} = res.data;
          this.alarm_detail_list = items;
          this.query_params.cn = currentPage;
          this.query_params.sn = limit;
          this.query_params.tn = total;
        } else {
          this.$mtd.message.error(this.$getText('wenshu_web_failed_to_get_data', '获取数据失败'));
        }
      });
    },

    reset_search_form() {
      this.query_params.fileName = '';
      this.query_params.fileNameLike = '';
      this.query_params.operate_time = [];
      this.query_params.operateType = '';
      this.query_params.dataSource = null;
      this.list_file_detail();
    },

    change_page(current, size) {
      this.query_params.cn = current;
      this.query_params.sn = size;
      this.list_file_detail();
    },
    report(row) {
      this.form_data.detailId = row.id;
      this.form_data.fileMd5 = row.filemd5;
      this.form_data.fileName = row.filename;
      this.form_data.misId = row.misid;
      this.reportModal = true;
    },
    closeModal() {
      this.form_data = {
        detailId: null,
        fileMd5: null,
        fileName: null,
        misId: null,
        reportReason: ''
      };
      this.reportModal = false;
    },
    submitReason() {
      this.api_file_detail_report(this.form_data).then(() => {
        this.$mtd.message.success(this.$getText('wenshu_web_report_successful', '举报成功'));
        this.closeModal();
        this.list_file_detail();
      });
    },
    getI18nTag(tag) {
      switch (tag) {
        case '查看':
          return this.$getText('wenshu_mobile_view', '查看');
        case '转发':
          return this.$getText('wenshu_mobile_forward', '转发');
        case '下载':
          return this.$getText('wenshu_mobile_download', '下载');
        case '外发':
          return this.$getText('wenshu_mobile_external_share', '外发');
      }
    }
  }
}
</script>

<style scoped>
@import "../../../styles/public.css";
@import "../../../styles/reset_table.css";

.search-block {
  background: #F7F7F7;
  padding: 12px 16px;
}

.search-block .mtd-form-item {
  width: 100%;
}

</style>
